import { constants } from "../../../constants";

export default class Error {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    SLINGO_handler(msg) {
        this.gb.emitters.emit.web.error(msg);
    }

    // GSBINGO_handler(msg) {
    //     this.gb.emitters.emit.web.error(msg);
    // }

    EZUGI_handler(msg) {
        this.gb.emitters.emit.web.error(msg.code);
    }

    SYN_handler(payload) {
        if (payload.data && payload.data.code) {
            this.gb.emitters.emit.web.error(payload.data.code);
        } else {
            this.gb.emitters.emit.web.error();
        }
    }

    PT_handler(payload) {
        if (payload && payload.error && payload.error.type) {
            this.gb.emitters.emit.web.error(payload.error.type)
        }
    }


    _default(msg) {
        this.gb.emitters.emit.web.error(msg);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SLINGO:
                event["genericError"] = this.SLINGO_handler;
                break;
            case constants.PNG:
                event["gameError"] = this._default;
                break;
            case constants.EZUGI:
                event["error"] = this.EZUGI_handler;
                break;
            case constants.EVOLUTION:
                event["SESSION_INVALID"] = this._default;
                break;
            case constants.BGS:
                event["genericError"] = this._default;
                break;
            case constants.RGU:
                event["genericError"] = this._default;
                break;
            case constants.RAW:
                event["genericError"] = this._default;
                break;
            case constants.HB:
                event["genericError"] = this._default;
                break;
            case constants.WD:
                event["WGEAPI.notifyGameError"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["ERROR"] = this._default;
                break;
            case constants.SYN:
                event["g2p.error"] = this.SYN_handler;
                event["g2p.gameFailed"] = this._default;
                break;
            case constants.PT:
                event["ucip.errors.g2wErrorNotification"] = this.PT_handler;
                break;
            case constants.YGG:
                event["request/error"] = this._default;
                break;
            case constants.SPIN:
                event["error"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["gameLoadingError"] = this._default;
                break;
            default:
                event["error"] = this._default;
                event["rg2xcErrorOccurred"] = this._default;
        }

        return event;
    }
}
